module.exports = __webpack_public_path__ + "media/components/therapists/intercom-logo-9ede4d753793fa18aff457f93c875607.png";